export default __webpack_public_path__ + "static/media/pcbArena.dc195f14.svg";